import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-quyu",
  "use": "icon-quyu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-quyu\"><path d=\"M512 0c254.464 0 460.8 169.7792 460.8 379.1872S742.4 1024 512 1024 51.2 588.6464 51.2 379.1872C51.2 169.7792 257.536 0 512 0z m0 256C427.1616 256 358.4 314.9312 358.4 387.6352c0 72.704 68.7616 131.6864 153.6 131.6864s153.6-58.9312 153.6-131.6864C665.6 314.9312 596.8384 256 512 256z\" fill=\"#8a8a8a\" p-id=\"2145\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol